import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box, useTheme, makeStyles } from "@material-ui/core";

import Divider from "../Divider";
import { setSelectedInsurance } from "../../redux/InsuranceTypes";

const useStyles = makeStyles({
  borderBottomRadius: {
    borderBottomLeftRadius: 13,
    borderBottomRightRadius: 13
  },
  imageContainer: (props) => ({
    cursor: "pointer",
    transform: props.hover && "scale(1.2)"
  })
});

export default function SubProductCard({
  product,
  insurance,
  productLocalInfo,
  retrieveInfo,
  active
}) {
  const [hover, setHover] = useState(false);

  const theme = useTheme();
  const classes = useStyles({ hover });

  const history = useHistory();
  const dispatch = useDispatch();

  const { productId, longDesc } = product;
  const { img, desc } = productLocalInfo;

  const handleClick = () => {
    if (!retrieveInfo) {
      dispatch(
        setSelectedInsurance({
          insuranceProductId: productId
        })
      );
      history.push(`${insurance.url}/planes`);
    }
  };

  const bgColor = hover
    ? theme.palette.secondary.main
    : theme.palette.primary.main;

  useEffect(() => {
    setHover(active);
  }, [active]);

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width={{ xs: "110px", sm: "200px" }}
        height={{ xs: "111px", sm: "187px" }}
        borderRadius="10px"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={!active && (() => setHover(false))}
        bgcolor={bgColor}
        className={classes.imageContainer}
        onClick={handleClick}
      >
        <img
          src={img || insurance.logo}
          alt=""
          style={{ width: "45%", height: "auto" }}
        />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        bgcolor={hover ? "#f6f9fa" : ""}
        maxWidth="214px"
        className={classes.borderBottomRadius}
      >
        <Box
          component="span"
          mt="24px"
          fontSize={{ xs: 14, sm: 25 }}
          fontWeight={hover ? "fontWeightBold" : 300}
          color={hover ? theme.palette.primary.main : ""}
        >
          {longDesc}
        </Box>

        {desc && (
          <>
            <Divider width="52px" my="16px" />
            <Box
              component="p"
              dangerouslySetInnerHTML={{
                __html: desc
              }}
              p={0}
              m={0}
              width="100%"
              flexDirection={12}
            ></Box>
          </>
        )}
      </Box>
    </Box>
  );
}
